import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { Trans } from "react-i18next";

export const AddNewButton = ({
  resource,
  className,
  match,
  readOnly,
  fullURL,
  ...props
}) =>
  readOnly ? null : (
    <Link
      className={classNames("btn btn-primary", className)}
      to={`${match?.url || fullURL}/new`}
      {...props}
    >
      <span className="fa fa-plus mr-1" />
      <Trans>Add New {resource}</Trans>
    </Link>
  );

export default AddNewButton;
